export const PROXY_MQTT_ORGANIZATIONS = [
  // "ee20510a-e365-4bd3-915b-8e578a3e5b23",
];
